import { Component, Output, EventEmitter, Input} from "@angular/core";

import { IDropdownItem, IDropdown } from "../components/dropdown.component";
import { SubsampleService } from "../services/subsample.service";
import { ISampleCategory } from "../models/sample-category.model";

interface ICatDropdown extends IDropdown {
	name?: string;
}

@Component({
	selector: "sample-type",
	template: `<div class="row">
			<div class="col-sm-5">
				<div class="form-group">
					<label for="category">Sample Type Main Category</label>
					<dropdown [id]="'category-dropdown'"
						[rows]="8"
						[isLiveSearch]="'true'"
						[dropdownItems]="categoryDropdownItems"
						[model]="category"
						(dropdownChanged)="categoryChanged($event)"></dropdown>
          <div class="alert alert-warning font-size-xs" [ngClass]="{'hidden': _validCategoryInput === true}">
					  Please select the Main Category.
				  </div>
				</div>
			</div>
			<div class="col-sm-6" *ngIf="subcategoryDropdownItems.length>0">
				<div class="form-group">
					<label for="subcategory">Sample Type Secondary Category</label>
					<dropdown [id]="'subcategory-dropdown'"
						[rows]="8"
						[isLiveSearch]="'true'"
						[dropdownItems]="subcategoryDropdownItems"
						[model]="subcategory"
						(dropdownChanged)="subcategoryChanged($event)"></dropdown>
          <div class="alert alert-warning font-size-xs" [ngClass]="{'hidden': _validSubcategoryInput === true}">
					  Please select the Secondary Category.
				  </div>
				</div>
			</div>
		</div>`
})
export class SampleTypeComponent {
	categoryDropdownItems: IDropdownItem[] = [];
	subcategoryDropdownItems: IDropdownItem[] = [];
	categorySubcategoryAll: ISampleCategory[] = [];

  category: ICatDropdown = { selected: -1, buttonText: "Choose..." };
  subcategory: ICatDropdown = { selected: -1, buttonText: "Choose..." };

  _validCategoryInput = false;
  _validSubcategoryInput = false;

  @Input() get validCategoryInput() {
    return false;
  }
  set validCategoryInput(value) {
    this._validCategoryInput = value || false;
  }

  @Input() get validSubcategoryInput() {
    return false;
  }
  set validSubcategoryInput(value) {
    this._validSubcategoryInput = value || false;
  }

	@Output() onCategoryChanged: EventEmitter<IDropdownItem> = new EventEmitter<IDropdownItem>();
  @Output() onSubcategoryChanged: EventEmitter<IDropdownItem> = new EventEmitter<IDropdownItem>();
  @Output() loadSubcategoriesLength: EventEmitter<number> = new EventEmitter<number>();

  constructor(private subsampleService: SubsampleService) { }

	ngOnInit() {
		this.subsampleService.getSampleCategorySubcategoryAll()
			.then((response: ISampleCategory[]): void => {
				this.categorySubcategoryAll = response;
        for (let i = 0, size = response.length; i < size; i++) {
          if (response[i].isActiveCategory)
              this.categoryDropdownItems.push({ value: response[i].categoryId || -1, text: response[i].categoryName || ""});
        }
        this.loadSubcategoriesLength.emit(response.length);
        this.category = { selected: -1, buttonText: "Choose..." };
        this.subcategory = { selected: -1, buttonText: "Choose..." };
      }, () => { });
	};

	categoryChanged(category: IDropdownItem) {
		this.subcategoryDropdownItems = [];
		this.subcategory.selected = -1;
		let categoryId = category.value;

		for (let categ of this.categorySubcategoryAll) {
      if (categ.categoryId === categoryId && categ.subcategories && categ.subcategories.length > 0) {
        for (let subcateg of categ.subcategories) {
          this.subcategoryDropdownItems.push({ value: subcateg.id || -1, text: subcateg.name || "" });
        }
        this.loadSubcategoriesLength.emit(categ.subcategories.length);
      }
      if (categ.categoryId === categoryId && categ.subcategories && categ.subcategories.length === 0) {
        this.loadSubcategoriesLength.emit(0);
      }
    }
		this.onCategoryChanged.emit(category);
	};

	subcategoryChanged(subcategory: IDropdownItem) {
		this.onSubcategoryChanged.emit(subcategory);
	}

}
